import React from "react";
import { Provider } from "react-redux";
import WebThreeEnvironment from "./src/containers/web-three-environment";
import createStore from "./src/state/store";


// eslint-disable-next-line react/display-name,react/prop-types
const wrapRootElement = ({ element }) => {
  // Instantiating store in `wrapRootElement` handler ensures:
  //  - there is fresh store for each SSR page
  //  - it will be called only once in browser, when React mounts

  const store = createStore();
  return <Provider store={store}>
    <WebThreeEnvironment>
      {element}
    </WebThreeEnvironment>
  </Provider>;
  ;
};

export default wrapRootElement;